function attachProductEventListeners() {
  document
    .querySelectorAll(".colors-related li .product a")
    .forEach((element) => {
      if (element.dataset.listenerAttached) return;
      element.dataset.listenerAttached = true;
      element.addEventListener("click", function (event) {
        const itemEl = element.closest("li.item");
        if (itemEl && itemEl.classList.contains("plus")) {
          return;
        }
        event.preventDefault();

        var prd_url = element.getAttribute("prd_url");
        var prd_title = element.getAttribute("title");
        var prd_simg =
          element.getAttribute("prd_simg")?.replace("_small", "") || "";
        var prd_img =
          element.getAttribute("prd_img")?.replace("_small", "") || "";
        var prd_price = element.getAttribute("prd_price") || "";
        var prd_compare_price = element.getAttribute("prd_compare_price") || "";
        var prd_handle = element.getAttribute("prd_handle") || "";
        var prd_variant_id = element.getAttribute("prd_variant_id") || "";

        element
          .closest(".colors-related")
          .querySelectorAll("li .product")
          .forEach((product) => {
            product.classList.remove("active");
          });

        element.closest(".product").classList.add("active");

        var productCard = element.closest(".product-card");
        if (productCard) {
          var titleLink = productCard.querySelector("a.product-card-title");
          if (titleLink) titleLink.innerText = prd_title || "";

          var linkElement = productCard.querySelector(
            "figure.product-featured-image a.product-featured-image-link"
          );
          if (linkElement) linkElement.setAttribute("href", prd_url);

          var imgElement = productCard.querySelector("img.product-primary-image");
          if (imgElement) {
            imgElement.setAttribute("src", prd_img);
            imgElement.removeAttribute("srcset");
          }

          var hoverElement = productCard.querySelector("img.productHoverImg");
          if (hoverElement) hoverElement.setAttribute("src", prd_simg);

          var priceIns = productCard.querySelector("span.price ins span.amount");
          if (priceIns && prd_price) priceIns.textContent = prd_price;

          var priceDel = productCard.querySelector("span.price del");
          if (prd_compare_price) {
            if (priceDel) {
              var priceDelAmount = priceDel.querySelector("span.amount");
              if (priceDelAmount) priceDelAmount.textContent = prd_compare_price;
              priceDel.style.display = "";
            } else {
              var priceIns2 = productCard.querySelector("span.price ins");
              if (priceIns2) {
                var newDel = document.createElement("del");
                newDel.innerHTML =
                  '<span class="amount">' + prd_compare_price + "</span>";
                priceIns2.parentNode.insertBefore(newDel, priceIns2);
              }
            }
          } else if (priceDel) {
            priceDel.style.display = "none";
          }

          productCard
            .querySelectorAll("quick-view[data-product-handle]")
            .forEach(function (qv) {
              if (prd_handle) qv.dataset.productHandle = prd_handle;
            });

          var atcBtn = productCard.querySelector(
            ".product-card--add-to-cart-button-simple"
          );
          if (atcBtn && prd_variant_id) atcBtn.dataset.productId = prd_variant_id;
        } else {
          var productContainer = element.closest("li.product");
          if (!productContainer) return;

          var titleEl = productContainer.querySelector(".product__title");
          if (titleEl) {
            var firstNode = titleEl.firstChild;
            if (firstNode && firstNode.nodeType === Node.TEXT_NODE) {
              firstNode.textContent = (prd_title || "") + " ";
            } else {
              titleEl.insertBefore(
                document.createTextNode((prd_title || "") + " "),
                titleEl.firstChild
              );
            }
            var colorNameSpan = titleEl.querySelector(".js-color-name");
            if (colorNameSpan) colorNameSpan.textContent = "";
          }

          var imgLink =
            productContainer.querySelector(".product__image > a") ||
            productContainer.querySelector(":scope > a");
          if (imgLink) imgLink.setAttribute("href", prd_url);

          var oldImg = productContainer.querySelector(".product__image img");
          if (oldImg && prd_img) oldImg.setAttribute("src", prd_img);

          var hoverDiv = productContainer.querySelector(
            "div[style*='background-image']"
          );
          if (hoverDiv && prd_simg) {
            hoverDiv.style.backgroundImage = "url(" + prd_simg + ")";
          }

          var oldPriceEl = productContainer.querySelector(
            "span.product__price span.price"
          );
          if (oldPriceEl && prd_price) oldPriceEl.textContent = prd_price;

          var compareEl = productContainer.querySelector("span.product__price--old");
          if (compareEl) {
            if (prd_compare_price) {
              compareEl.textContent = prd_compare_price;
              compareEl.style.display = "";
            } else {
              compareEl.style.display = "none";
            }
          }

          if (prd_handle && productContainer.classList.contains("js-product")) {
            fetch("/products/" + prd_handle + ".js")
              .then(function (r) { return r.json(); })
              .then(function (fetchedProduct) {
                productContainer.dataset.productId = fetchedProduct.id;
                var select = productContainer.querySelector(
                  "select.product-single__variants"
                );
                if (!select) return;
                select.innerHTML = fetchedProduct.variants
                  .map(function (v) {
                    var attrs =
                      ' value="' + v.id + '" data-sku="' + (v.sku || "") + '"';
                    if (v.option1 != null) attrs += ' data-option1="' + v.option1 + '"';
                    if (v.option2 != null) attrs += ' data-option2="' + v.option2 + '"';
                    if (v.option3 != null) attrs += ' data-option3="' + v.option3 + '"';
                    if (!v.available) attrs += ' disabled="disabled"';
                    return "<option" + attrs + ">" + v.title + "</option>";
                  })
                  .join("");
              })
              .catch(function (e) {
                console.error("Swatch product fetch error:", e);
              });
          }
        }
      });
    });
}

function initColorsRelated() {
  const blocks = document.querySelectorAll(".colors-related");
  if (blocks.length === 0) return;

  attachProductEventListeners();

  blocks.forEach((targetNode) => {
    if (targetNode.dataset.swatchObserved) return;
    targetNode.dataset.swatchObserved = true;
    const sectionObserver = new MutationObserver((mutList) => {
      for (const mutation of mutList) {
        if (mutation.type === "childList") {
          setTimeout(() => attachProductEventListeners(), 100);
        }
      }
    });
    sectionObserver.observe(targetNode, { childList: true, subtree: true });
  });
}

const PRODUCT_CARD_CONTAINERS = [
  ".section-recommendation-products",
  ".prds_list",
  ".featured-collection",
  ".collection-container",
  "product-recommendations",
  ".section-collection-tabs",
].join(", ");

const waitForColorsRelated = new MutationObserver(() => {
  initColorsRelated();
});

function observeProductSections() {
  document.querySelectorAll(PRODUCT_CARD_CONTAINERS).forEach((el) => {
    if (el.dataset.waitObserved) return;
    el.dataset.waitObserved = true;
    waitForColorsRelated.observe(el, { childList: true, subtree: true });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initColorsRelated();
  observeProductSections();
});
